import React, { useState, useEffect, useContext } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { ApiContext } from '../App';
import { Loader2 } from 'lucide-react';
import IndividualSidebar from '../components/individuals/IndividualSidebar';
import { toast } from 'react-toastify';
import { useLocation } from 'react-router-dom';

const IndividualDetailPage = () => {
  const params = useParams();
  const navigate = useNavigate();
  const location = useLocation();
  const pathname = location.pathname;
  const API = useContext(ApiContext);
  const [individual, setIndividual] = useState(null);
  const [loading, setLoading] = useState(true);

  // Détection du type de route
  const individualId = params.candidateId || params.contactId || params.id;
  const isFromPosition = !!params.candidateId && !!params.id; // /positions/:id/candidates/:candidateId
  const isFromBizdev = !!params.candidateId && !!params.processId; // /process/bizdev/:processId/candidates/:candidateId
  const isFromPartner = !!params.contactId && !!params.id; // /partners/:id/contacts/:contactId
  const isFromHome = pathname.startsWith('/app/contacts/'); // /app/contacts/:contactId

    useEffect(() => {
    const fetchIndividual = async () => {
      try {
        setLoading(true);
        const response = await API.get(`/api/individuals/${individualId}`);
        setIndividual(response.data);
      } catch (error) {
        toast.error('Erreur lors du chargement du profil');
        if (isFromPosition) {
          navigate(`/positions/${params.id}`);
        } else if (isFromBizdev) {
          navigate(`/process/bizdev/${params.processId}`);
        } else if (isFromPartner) {
          navigate(`/partners/${params.id}`);
        } else if (isFromHome) {
          navigate('/app');
        } else {
          navigate('/all-individuals');
        }
      } finally {
        setLoading(false);
      }
    };

    if (individualId) fetchIndividual();
  }, [individualId, API, navigate, params, isFromPosition, isFromBizdev, isFromPartner, isFromHome]);


  const handleClose = () => {
    if (isFromPosition) {
      navigate(`/positions/${params.id}`);
    } else if (isFromBizdev) {
      navigate(`/process/bizdev/${params.processId}`);
    } else if (isFromPartner) {
      navigate(`/partners/${params.id}`);
    } else if (isFromHome) {
      navigate('/app');
    } else {
      navigate('/all-individuals');
    }
  };

  // Fonction pour rafraîchir les données après une mise à jour d'étape
  const handleStageUpdate = async () => {
    try {
      const response = await API.get(`/api/individuals/${individualId}`);
      setIndividual(response.data);

      // Si on est dans un contexte de position, on peut déclencher un refresh du kanban via l'URL
      // Le composant parent (ProcessBoardThree) devra écouter les changements de hash ou utiliser un event
      if (isFromPosition || isFromBizdev) {
        // On peut déclencher un event custom pour notifier le parent
        window.dispatchEvent(new CustomEvent('candidateStageUpdated', { detail: { individualId } }));
      }
    } catch (error) {
      console.error('Error refreshing individual:', error);
    }
  };

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-gray-50">
        <div className="text-center">
          <Loader2 className="w-12 h-12 animate-spin mx-auto mb-4 text-indigo-600" />
          <p className="text-gray-600">Chargement du profil...</p>
        </div>
      </div>
    );
  }

  if (!individual) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-gray-50">
        <div className="text-center">
          <p className="text-gray-600 mb-4">Profil introuvable</p>
          <button
            onClick={handleClose}
            className="px-4 py-2 bg-indigo-600 text-white rounded-lg hover:bg-indigo-700 transition-colors"
          >
            Retour à la liste
          </button>
        </div>
      </div>
    );
  }

  return (
    <>
      {/* Overlay semi-transparent */}
      <div
        className="fixed inset-0  z-40"
        onClick={handleClose}
      />

      {/* Sidebar qui glisse depuis la droite */}
      <div className="fixed inset-y-0 right-0 w-full md:w-4/5 lg:w-3/4 xl:w-2/3   z-50 overflow-hidden">
        <IndividualSidebar
          isOpen={true}
          onClose={handleClose}
          individual={individual}
          theme="light"
          onStageUpdate={handleStageUpdate}
        />
      </div>
    </>
  );
};

export default IndividualDetailPage;
